import React from "react"
import Style from "../styles/aside.module.css"

export default ({children}) => (
    <aside className={Style.box}>
        {children}
    </aside>
)